<template>
  <div class="private_container">
    <div class="private_box">
      <div class="title_box">
        <div class="h2"><span>{{appFullName}}隐私政策</span></div>
      </div>
       <div class="content_box">
        <div class="block_box">
          <p>尊敬的“法治号”客户端用户，欢迎您使用“法治号”客户端。我们非常重视您的个人隐私信息保护，将恪守适用法律和我们对您的承诺，并致力于维持您对我们的信任，尽全力保证您的个人信息安全和合理使用。同时，我们郑重承诺，我们将按成熟的互联网安全标准，采取相应的安全保护措施来保护您的个人信息。</p>
          <p>为帮助您了解我们收集哪些数据、为什么收集这些数据、利用这些数据做些什么以及如何加以保护，我们订立了本政策。若您使用“法治号”客户端提供的服务，即表示您认同我们在本政策中所述内容。如需将您的信息用于本协议未涵盖的用途时，我们会事先征求您的同意。</p>
          <p>本软件尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，本软件会按照本隐私权政策的规定使用和披露您的个人信息。但本软件将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本软件不会将这些信息对外披露或向第三方提供。本软件会不时更新本隐私权政策。您在同意本软件服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于本软件服务使用协议不可分割的一部分。</p>
        </div>
        <div class="h4">
          <span>一、</span><span>我们如何收集和使用您的个人信息</span>
        </div>
        <div class="block_box">
          <p>我们会按照合法、必要、正当的原则收集和使用您的下列个人信息：</p>
          <p>（一）我们会收集由您向我们提供的信息，此类信息包括：</p>
          <p>（1）当您未注册成为我们会员使用我们的服务时，您无需向我们提供您的个人信息。您可以使用基础的资讯浏览功能及服务功能。</p>
          <p>（2）当您以第三方账号认证会员使用我们的服务时，您需要提供您的第三方账号认证ID、用户昵称、头像信息，您可以使用我们为您提供的快捷登录方式。</p>
          <p>（3）当您以手机号认证会员使用我们的服务时，您需要提供您的手机号码信息。您可以在原有基础上使用我们为您提供的资讯评论、积分获取、答题抽奖互动功能。</p>
          <p>（4）此外，我们还收集您的性别、邮箱、所在城市、地址信息，以便为您提供更优质的服务。您可以选择不提供此类信息，不会影响您对“法治号”客户端正常使用。</p>
          <p>（二）我们会收集您在使用“法治号”客户端过程中产生的信息，此类信息包括：</p>
          <p>（1）设备信息</p>
          <p>为了提供更好的产品和服务并改善用户体验，我们会根据您在软件安装或使用过程中授权的具体权限，接收并记录您所使用的设备相关信息，包括您的imei、IMSI号、Mac地址、操作系统版本信息、设备设置、移动设备版本、软件列表、android ID、设备识别码、屏幕分表率、设备环境软硬件特征信息、设备所在位置相关信息，包括IP地址、GPS位置以及能够提供相关信息的WLAN接入点、蓝牙和基站传感器信息。如果您在安装或使用过程中拒绝授予我们相应权限的，我们并不会记录您上述对应的信息。获取软件安装列表，主要是用于展示app 设置页中版本号的信息。</p>
          <p>（2）日志信息</p>
          <p>当您使用“法治号”客户端时，我们的服务器会自动记录一些信息。例如，您在“法治号”客户端的使用情况，包括访问服务的日期、时间、时长。您可以拒绝提供此类信息，但您将无法获得相关服务。</p>
          <p>（3）位置信息</p>
          <p>当您使用“法治号”客户端具有定位功能的服务应用时，在您开启设备定位功能并使用我们基于位置提供的相关服务时，我们会收集和处理有关您实际所在位置的信息，用于帮助您在分布的信息中展示位置或丰富信息推荐维度。您可以通过关闭定位功能，停止对您的地理位置信息的收集，但您将无法获得相关服务或功能，或者无法达到相关服务拟达到的效果。</p>
          <p>（4）相册信息</p>
          <p>我们会申请拍照、相册、存储等权限，用于发布、下载图文/视频及缓存相关内容，您可以通过关闭拍照、相册、存储读取权限功能，停止对您的相册、存储信息的收集，但您将无法获得相关服务或功能，或者无法达到相关服务拟达到的效果。</p>
          <p>（5）用户行为信息</p>
          <p>当您使用“法治号”客户端服务时，我们将收集您的服务使用频率以及您使用的高频服务事项名称，以及您在个人中心设置的个人标签、地址信息、性别、职业信息以便为您提供更适合您的服务。</p>
          <p>（三）第三方软件开发包（SDK）个人信息收集情况:</p>
          <p>为了使您能够在使用我们的服务时收到信息推送、在第三方平台分享信息、利用第三方平台账号进行登录及保障您的账号安全，我们集成了由第三方公司开发、提供的软件开发包（SDK），这些软件开发包（SDK）在实现功能时需要采集部分信息才可实现，具体如下：</p>
          <p>（1）极光推送SDK。需要申请推送权限，收集您的设备信息，提供消息推送功能。</p>
          <p>（2）百度地图SDK。需要申请位置、语音权限，收集您的地理位置、音频信息，提供地图功能。</p>
          <p>（3）微信SDK。无需申请任何权限，收集您的用户ID，提供微信分享功能。</p>
          <p>（4）QQSDK。无需申请任何权限，未收集任何个人信息，提供QQ分享功能。</p>
          <p>（5）七牛云SDK。无需申请任何权限，未收集任何个人信息，提供图片、视频上传功能。</p>
        </div>
        <div class="h4">
          <span>二、</span><span>我们如何共享、转让、公开披露您的个人信息</span>
        </div>
        <div class="block_box">
          <p>（一）共享</p>
          <p>我们遵照法律法规的规定，对信息分享进行严格的限制，如果为了向您提供服务而需要将您的信息共享至第三方，我们将评估该第三方收集信息的合法性、正当性、必要性。我们将要求第三方对您的信息采集采取保护措施并严格遵守相关法律法规与监管要求。另外，我们会按照法律法规及国家标准要求以确认协议、具体场景下的文案确认、弹窗提示形式征得您的同意或确认第三方已经征得您的同意。除以下情形外，未经您同意，我们不会与任何第三方分享您的个人信息：</p>
          <p>（1）事先获得您明确的同意或授权。</p>
          <p>（2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供。</p>
          <p>（3）为了让您使用“法治号”客户端的服务，我们需要向您收集必要的个人信息；对于某些由第三方或由我们与第三方共同提供的服务，只有共享您的信息，我们才能提供您需要的服务。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享与提供服务相关的个人信息，且受本隐私政策中所声明目的的约束。</p>
          <p>（4）实现安全与统计分析。分析我们服务的使用情况，提升用户使用体验，会与关联方或第三方共享产品使用情况（崩溃、闪退）的统计性数据。</p>
          <p>对我们与之共享个人信息的第三方，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私协议以及其他任何相关的保密和安全措施来处理个人信息。</p>
          <p>（二）转让和公开披露</p>
          <p>我们不会将您的个人信息转让或公开披露，但以下情形除外：</p>
          <p>（1）事先获得您的明确授权或同意；</p>
          <p>（2）基于法律法规的要求或各类执法要求。</p>
          <p>（三）根据相关法律法规和国家标准，在以下情形中，我们会依法共享、转让、公开披露您的个人信息而无需征得您的同意：</p>
          <p>（1）与国家安全、国防安全直接相关的。</p>
          <p>（2）与公共安全、公共卫生、重大公共利益直接相关的。</p>
          <p>（3）犯罪侦查、起诉、审判和判决执行直接相关的。</p>
          <p>（4）出于维护您或其他个人的生命、财产重大合法权益但又很难得到本人同意的。</p>
          <p>（5）您自行向社会公众公开的个人信息。</p>
          <p>（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开渠道。</p>
          <p>（7）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障。</p>
          <p>（8）法律法规规定的其他情形。</p>
          <p>根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>
          <p>（四）其他</p>
          <p>请您理解，我们向您提供的服务是不断更新和发展的。如您选择使用了前述说明中尚未涵盖的其他服务，基于该服务我们需要收集您的其他信息的，我们会通过页面提示、交互流程、协议约定方式另行向您进行说明收集信息的范围及目的，并征得您的同意。我们会按照本政策以及相应的用户服务协议约定使用、存储、使用及对外提供您的信息；如您选择不提供前述信息，您无法使用某项或某部分服务，但不影响您使用我们提供的其他服务。此外，第三方主体通过我们向您提供服务，当您进入第三方主体运营的服务页面时，请注意相关服务由第三方主体向您提供。涉及到第三方主体向您收集个人信息的，建议您仔细查看第三方主体的隐私政策或协议约定。</p>
        </div>
        <div class="h4">
          <span>三、</span><span>我们如何保存、保护及删除您的个人信息</span>
        </div>
        <div class="block_box">
          <p>（一）保存和删除</p>
          <p>您在使用“法治号”客户端的产品及服务期间，我们将持续为您保存您的个人信息，法律法规另有规定的除外。</p>
          <p>您应当知道并同意，由于本软件有部分政务类服务，对于公安系统和有关部门固有的居民信息，在本软件平台删除并不意味着在公安系统和有关部门进行删除。比如一般情况下，特定政务服务中的电子卡信息，如驾驶证、行驶证、身份证和居住证信息，为公安系统或有关政府部门记载的信息。此类信息与“法治号”客户端具有相对独立性。</p>
          <p>您的个人信息均储存于中华人民共和国境内。</p>
          <p>（二）保护</p>
          <p>为了保障您的信息安全，我们会采用符合互联网安全标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的信息遭到未经授权的访问和修改，避免数据的丢失、损毁和不当使用。</p>
          <p>我们非常重视信息安全。我们委派了专责团队负责研发和应用多种安全技术和程序，我们会对安全管理负责人和关键安全岗位的人员进行安全背景审查，我们建立了完善的信息安全管理制度和内部安全事件处置机制。我们会采取符合互联网标准的合理可行的安全措施和技术手段存储和保护您的个人信息，以防止您的信息丢失、遭到被未经授权的访问、公开披露、使用、修改、毁损、丢失或泄漏。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击。</p>
          <p>我们部署了数据访问控制机制，对处理个人信息的人员进行严格的权限控制，并会与接触您个人信息的合作方签署保密协议（如有），明确岗位职责及行为准则，确保只有被授权人员才可访问个人信息。若有违反保密协议的行为，会被追究相关责任。</p>
          <p>在发生个人信息安全事件时，我们会立即启动应急预案，采取相应的补救措施，在最短时间内追溯原因并减少损失。与此同时，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和的影响、我们已采取或将要采取的处理措施、您可自主防范和降低风险的建议、对您的补救措施。我们将及时将事件相关情况以短信、电话、推送通知方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</p>
          <p>我们提醒您注意，互联网并非绝对安全的环境，尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但我们仍然无法保证你的个人信息通过不安全途径进行交流时的安全性。因此，用户应采取积极措施保证个人信息的安全，如：定期修改账号密码，不将自己的账号密码个人信息透露给他人。</p>
        </div>
        <div class="h4">
          <span>四、</span><span>我们如何使用Cookie同类技术</span>
        </div>
        <div class="block_box">
          <p>为了使您获得便捷流畅的访问体验，当您使用“法治号”客户端及相关服务时，我们会在您的终端设备通过Cookie小型数据文件用来识别您的身份，这么做可帮您省去重复输入登录信息的步骤，或者帮助判断您的账户安全状态。我们不会将上述技术收集的信息用于本隐私政策所述目的之外的任何用途。请您理解，我们的某些服务只能通过使用“Cookie”才可得到实现。</p>
          <p>Cookie可以使得我们更好、更快地为您提供服务。当然，您可以在“法治号”客户端手机端清除Cookie数据文件或者您的浏览器或浏览器附加服务允许，可以在浏览器设置Cookie的接受程度，但这一举动在某些情况下会影响您安全访问“法治号”客户端相关平台提供的服务。</p>
        </div>
        <div class="h4">
          <span>五、</span><span>第三方服务</span>
        </div>
        <div class="block_box">
          <p>如果我们接入第三方社交媒体或其他服务，如使用第三方社交媒体的分享功能，地图类软件的定位功能，或者整合其他第三方的服务，则这类服务均由相关的第三方负责运营。 在使用过程中，第三方服务提供者会收集、使用和存储您的相关数据或信息。您决定使用该类服务前，须受第三方自己的服务条款及信息保护声明（而非本《隐私政策》）约束，请您仔细阅读其条款。本《隐私政策》仅适用于我们所收集的任何信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，但我们会尽力要求所有链接的第三方网站采用同的个人信息保护措施。 </p>
        </div>
        <div class="h4">
          <span>六、</span><span>您的权利</span>
        </div>
        <div class="block_box">
          <p>按照相关法律法规的规定，我们保障您对自己的个人信息行使以下权利：</p>
          <p>（一）访问您的个人信息</p>
          <p>您有权访问您的个人信息，法律法规另有规定的除外。如果您无法访问个人信息，您可以联系我们反馈问题。</p>
          <p>（二）更正您的个人信息</p>
          <p>您发现我们处理的关于您的个人信息有错误时，您有权对错误或不完整的信息作出更正或更新，您可以与我们联系反馈。为保障安全，我们将在您行使更正权前对您的身份进行验证。</p>
          <p>（三）删除您的个人信息</p>
          <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
          <p>（1）如果我们违反法律法规或与您的约定收集、使用、与他人共享或转让您的个人信息。</p>
          <p>（2）如果我们违反法律法规规定或与您的约定，公开披露您的个人信息，您有权要求我们立即停止公开披露的行为，并发布通知要求相关接收方删除相应的信息。</p>
          <p>当您从我们的服务中删除信息后，我们不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>
          <p>（四）改变您授权同意的范围</p>
          <p>如您想改变授权范围，您可通过联系我们或修改、关闭您设备的隐私权限修改授权范围。</p>
          <p>当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。</p>
          <p>（五）提前获知“法治号”客户端停止运营</p>
          <p>“法治号”客户端愿一直陪伴您，若因特殊原因导致“法治号”客户端平台产品和服务被迫停止运营，我们将按照法律法规要求通知您，并将停止对您个人信息的收集，同时会按照法律规定对所持有的您的个人信息进行删除或匿名化处理。</p>
          <p>(六）响应您的上述请求</p>
          <p>为保障安全，您需要提供书面请求，或以其他方式证明您的身份。我们会先要求您验证自己的身份，然后再处理您的请求。</p>
          <p>在以下情形中，按照法律法规要求，我们将无法响应您的上述请求：</p>
          <p>（1）与国家安全、国防安全直接相关的；</p>
          <p>（2）与公共安全、公共卫生、重大公共利益直接相关的。</p>
          <p>（3）与犯罪侦查、起诉、审判和执行判决直接相关的。</p>
          <p>（4）我们有充分证据表明您存在主观恶意或滥用权利的（如您的请求将危害公共安全和其他人合法权益，或您的请求超出了一般技术手段和商业成本可覆盖的范围）。</p>
          <p>（5）响应个人信息主体的请求将导致您或其他个人、组织的合法权益受到严重损害的。</p>
          <p>（6）法律法规规定的其他情形。</p>
        </div>
        <div class="h4">
          <span>七、</span><span>我们如何处理未成年人的个人信息</span>
        </div>
        <div class="block_box">
          <p>“法治号”客户端非常重视对未成年人信息的保护。</p>
          <p>我们的服务主要面向成年人。若您是未成年人，需与您的监护人共同操作，并仔细阅读本隐私政策。</p>
          <p>如您的监护人不同意您按照本政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。</p>
          <p>如果监护人发现我们在未获监护人同意的情况下收集了未成年人的个人信息，请联系我们，同时提交相关材料以便我们验证身份，我们会尽快审核并设法删除相关数据。</p>
        </div>
        <div class="h4">
          <span>八、</span><span>通知和修订</span>
        </div>
        <div class="block_box">
          <p>本政策自您以点击或其他方式确认同意之时生效。</p>
          <p>我们适时修订本政策内容。如该变更会导致您在本政策项下权利的实质减损，我们将在变更生效前，通过在页面显著位置提示方式通知您。我们会在本页面上发布对本隐私政策所做的任何变更。</p>
          <p>若您不同意该变更可以停止使用“法治号”客户端，若您继续使用“法治号”客户端，即表示您同意受修订后的本隐私政策的约束。</p>
        </div>
        <div class="h4">
          <span>九、</span><span>如何联系我们</span>
        </div>
        <div class="block_box">
          <p>运营机构&开发者：法治日报社</p>
          <p>注册地址：北京市朝阳区花家地甲1号</p>
          <p><span>如您对本政策或其他相关事宜有疑问，您可以通过【</span><span class="quotation">bxxb@legaldaily.com.cn</span><span>】进行咨询。</span></p>
          <p class="bottom_date">
            <span>法治日报社</span>
          </p>
          <p class="bottom_date">
            <span>2022年3月5日</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import commApi from "@/api/apis/common.js";
export default {
  name: "Private",
  data() {
    return {};
  },
  computed: {
    ...mapState("app", ["nodeCode", "appFullName"]),
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: location.href
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, _this.appFullName + "隐私政策", _this.appFullName, location.href);
      }).catch((err) => {

      })
    },
  },
  created() {
    document.title = this.appFullName + "隐私政策";
    this.wechatShare(); // 微信二次分享
    loadStat(); // 友盟统计
  },
};
</script>
<style scoped lang="scss">
.private_container {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .private_box {
    padding: 15px;
    overflow-x: hidden;
    overflow-y: auto;
    * {
      word-break: normal;
      white-space: normal;
      line-height: 1.5em;
      font-family: "Microsoft Yahei";
    }
    .title_box {
      .h2 {
        padding: 18px 0;
        line-height: 27px;
        text-align: center;
        color: #212121;
        font-family: "Microsoft Yahei";
        font-size: 18px;
        font-weight: bolder;
        span {
          color: #212121;
          font-family: "Microsoft Yahei";
          font-weight: bolder;
        }
      }
    }
    .content_box {
      .h4 {
        margin-top: 15px;
        color: #000;
        font-family: "Microsoft Yahei";
        font-size: 18px;
        span {
          color: #000;
          font-family: "Microsoft Yahei";
          font-weight: bolder;
        }
      }
      p {
        margin: 5px 0;
        line-height: 27px;
        color: #000;
        font-family: "Microsoft Yahei";
        font-size: 16px;
        text-indent: 2em;
        text-align: justify;
        * {
          color: #000;
          font-family: "Microsoft Yahei";
          text-align: justify;
        }
        .quotation {
          font-family: "Arial", sans-serif;
        }
        &.bottom_date {
          margin: 5px 0;
          text-align: right;
        }
      }
    }
  }
}
</style>